let debounce = require('../../modules/debounce');
require('./cart-preview.less');
require('../m-scrollbar-default/m-scrollbar-default');

let size = require('../../modules/size');

jQuery(function() {
    function onResizeCartPreview() {
        var $cartPreview = $('.cart-preview');
        var $miniCartScroll = $cartPreview.find('.js-cart-items-scrollbar');
        var $miniCart = $('.mini-cart.header__cart');

        var $wrapper = $miniCart.closest('.wrapper');

        //обновление вертикального скролла при изменении ширины сайта
        // т.е. перешли из режима десктопа в мобильный и наоборот
        if ($cartPreview.hasClass('cart-preview--shown')) {
            if (window.innerWidth >= size.desktop) {
                $miniCartScroll.mCustomScrollbar({
                    axis: 'y'
                });

                var posWrapper = $wrapper.width() / 2;
                var posWindow = window.innerWidth / 2;
                var pos = Math.min(posWrapper, posWindow);
                pos -= $cartPreview.innerWidth() + 1;
                $cartPreview.css('margin-left', pos + 'px');
            } else {
                $miniCartScroll.mCustomScrollbar('destroy');
            }
        }
    }

    $(document).on('click', '.js-show-cart-preview', function() {
        if ($('.js-cart-preview').html() == '') {
            $.ajax({
                url: '/ajax/component/maximaster:small.basket.widget/cart-preview/',
                async: false,
                success: function(data) {
                    $('.js-cart-preview').html(data['html']);
                }
            });
        }

        var $cartPreview = $('.cart-preview');
        var $container = $cartPreview.closest('.main-container');
        var $miniCart = $('.mini-cart.header__cart');

        //надо сделать копию корзины из шапки, чтобы тень была единая вокруг
        //корзины в шапке и самом блоке выпадающей корзины (на десктопе)
        var $miniCartCopy = $miniCart.clone();
        $miniCartCopy.removeClass('header__cart js-show-cart-preview mini-cart--active');
        $cartPreview.find('.cart-preview__cart-copy').html($miniCartCopy);

        $container.toggleClass('main-container--shifted-right');
        $cartPreview.toggleClass('cart-preview--shown');
        $miniCart.toggleClass('mini-cart--active');

        $cartPreview.addClass('cart-preview--autoheight');
        if ($cartPreview.innerHeight() > $container.height())
            $container.css('min-height', $cartPreview.innerHeight() + 'px');
        $cartPreview.removeClass('cart-preview--autoheight');

        onResizeCartPreview();
    });

    debounce.setResizeDebounce(onResizeCartPreview);

    $(document).on('click', '.main-container--shifted-right .container, .js-close-cart-preview', function(e) {
        var $target = $(e.target);
        var $cartPreview = $('.cart-preview');
        var $container = $cartPreview.closest('.main-container');

        if (
            !$(this).hasClass('js-close-cart-preview') &&
            ($target.is($cartPreview) ||
                $target.closest('.cart-preview').length > 0 ||
                ($target.is('.mini-cart') || $target.closest('.mini-cart').length > 0))
        )
            return;

        e.stopPropagation();
        e.preventDefault();

        $container.removeClass('main-container--shifted-right');
        $('.mini-cart.mini-cart--active').removeClass('mini-cart--active');
        $cartPreview.removeClass('cart-preview--shown');
        $container.css('min-height', '0');
    });
});



// WEBPACK FOOTER //
// ./blocks/cart-preview/cart-preview.js